export function cdnHostCheck(data) {
    try {
        const cdnHost = data.cdnHost;
        if (!cdnHost) {
            return data;
        }
        const customBootstrapPopupDetail = JSON.stringify(data.customBootstrapPopupDetail);
        if (customBootstrapPopupDetail) {
            // 把符合这个模式的
            // "https://f12stag.kkmh.com/game"
            // "https://f2.kkmh.com/game"
            // 替换为 ${cdnHost}game
            // ${cdnHost} 是接口返回的，比如是 "https://tn1-f2.kkmh.com/"
            data.customBootstrapPopupDetail = JSON.parse(
                replaceLink(customBootstrapPopupDetail, cdnHost)
            );
        }
        data.displayModuleStyleConfigList.forEach((list) => {
            const styleDetail = JSON.stringify(list.styleDetail);
            list.styleDetail = JSON.parse(replaceLink(styleDetail, cdnHost));
        });
    } catch (error) {
        console.error(error);
    }
    return data;
}

function replaceLink(str, cdn) {
    const replaceText = `${cdn}game`;
    return str.replaceAll(/https:\/\/f(12stag|2)\.kkmh\.com\/game/g, replaceText);
}
